<template>
    <div id="settingpage">
        <h1>
            {{ title }}
        </h1>
        <div id="divider" />
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "SettingsPage",
    props: {
        title: {
            type: String,
            default: undefined
        }
    }
};
</script>

<style lang="scss">
#settingpage {
    background: white;
    box-shadow: 0px 0px 16px -2px rgba(0, 0, 0, 0.4);
    margin: 5vmin auto;
    padding: 15px 24px;
    max-width: 960px;
    width: 90vw;
    max-height: 85vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}
#settingpage > * {
    margin-top: 16px;
}
#settingpage > h1 {
    margin-top: 24px;
    margin-bottom: 0;
}
#divider {
    width: 100%;
    height: 2px;
    background: rgb(54, 54, 54);
}

.form-row {
    display: flex;
    flex-wrap: wrap;
}
.form-row > * {
    flex: 1;
    margin: 12px;
    min-width: 260px;
}
</style>
